import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from './Provider';

import * as ROUTES from '../../constants/routes';

const useAuthorization = condition => {
  const history = useHistory();
  const authUser = useContext(AuthContext);

  if (authUser && authUser.authenticated === false) {
    history.push(ROUTES.SIGN_IN);
  } else {
    if (!condition(authUser)) {
      history.push(ROUTES.SIGN_IN);
      return false;
    } else {
      return true;
    }
  }
};

export default useAuthorization;
